import { Button, Checkbox, DataSource, Layout, SearchPanel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOverdueEventsList extends Layout {
    buttonCancel: Button;
    checkboxIsActive: Checkbox;
    searchpanelEvents: SearchPanel;
    sourceOverdueEvent: DataSource;
    tableEvents: Table;
    textboxAlertType: Textbox;
    textboxDays: Textbox;
    textboxEventTableKey: Textbox;
    textboxEventTableName: Textbox;
    textboxOverdueDate: Textbox;
}
